import { Box, UnstyledButton } from "@dehub/theme";
import { CheckIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { ReasonTooltip } from "@/shared/a11y/reason-tooltip";
import classes from "../business.module.css";

export type StepNumber = 1 | 2 | 3;
export const STEPS: StepNumber[] = [1, 2, 3];

type Props = Readonly<{
  current: StepNumber;
  done: ReadonlySet<StepNumber>;
  /** Steps the user may jump to right now. */
  isReachable: (step: StepNumber) => boolean;
  onGo: (step: StepNumber) => void;
}>;

export function StepIndicator({ current, done, isReachable, onGo }: Props) {
  const { t } = useTranslation("business");

  return (
    <Box component="ol" className={classes.steps}>
      {STEPS.map((step) => {
        const reachable = isReachable(step);
        return (
          <Box key={step} component="li" className={classes.stepsItem}>
            <ReasonTooltip reason={reachable ? null : t("steps.locked")}>
              <UnstyledButton
                className={classes.step}
                data-active={current === step || undefined}
                data-done={(done.has(step) && current !== step) || undefined}
                aria-current={current === step ? "step" : undefined}
                onClick={() => onGo(step)}
              >
                <Box component="span" className={classes.stepNumber}>
                  {done.has(step) && current !== step ? <CheckIcon size={14} weight="bold" aria-hidden="true" /> : step}
                </Box>
                <Box component="span" className={classes.stepLabel}>
                  {t(`steps.s${step}.label`)}
                </Box>
              </UnstyledButton>
            </ReasonTooltip>
          </Box>
        );
      })}
    </Box>
  );
}
